"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductsTableMobileLayout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _useDebounce = require("use-debounce");
var _productsTableHead = require("./productsTableHead");
var _productsTableBody = require("./productsTableBody");
var _tableContext = require("./stateHelpers/tableContext");
var _useAlignHorizontalTables = require("../../hooks/useAlignHorizontalTables");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ProductsTableMobileLayout = exports.ProductsTableMobileLayout = function ProductsTableMobileLayout(_ref) {
  var _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? 'horizontal' : _ref$layout,
    showProductSelectFooters = _ref.showProductSelectFooters,
    onPlanSelect = _ref.onPlanSelect,
    onActiveProductGroupChange = _ref.onActiveProductGroupChange,
    onGroupDisplayStateChange = _ref.onGroupDisplayStateChange,
    onSelectedOptionChange = _ref.onSelectedOptionChange,
    _onTogglePlanVisibility = _ref.onTogglePlanVisibility,
    _ref$visiblePlans = _ref.visiblePlans,
    visiblePlans = _ref$visiblePlans === void 0 ? {} : _ref$visiblePlans;
  var containerRef = (0, _react.useRef)(null);
  var tableColumnRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldShowControl = _useState2[0],
    setControlShowState = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentItemIndex = _useState4[0],
    setCurrentItemIndex = _useState4[1];
  var throttledHandleScroll = (0, _useDebounce.useThrottledCallback)(function () {
    var _containerRef$current;
    var clientRect = containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect();
    var topOffset = clientRect.top;
    var bottomOffset = clientRect.bottom;
    var viewportHeight = window.innerHeight;
    var doShowSliderControl = topOffset - 0.5 * viewportHeight < 0 && bottomOffset - 0.5 * viewportHeight > 0;
    setControlShowState(doShowSliderControl);
  }, 100);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', throttledHandleScroll);
  }, [throttledHandleScroll]);
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableStat = _useContext.tableState,
    _useContext$tableStat2 = _useContext$tableStat.mobileSettings,
    mobileMode = _useContext$tableStat2.mobileMode,
    visibilityMap = _useContext$tableStat2.visibilityMap,
    dataIsUpdating = _useContext$tableStat.dataIsUpdating;
  (0, _useAlignHorizontalTables.useAlignMobileHorizontalTableRows)({
    currentLayout: layout,
    productTablesContainerRef: !dataIsUpdating && containerRef,
    mobileMode: mobileMode
  });
  var contentToggleable = layout === 'stacked';
  var SwipeInDirection = function SwipeInDirection() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'next';
    var _Object$keys = Object.keys(visiblePlans),
      length = _Object$keys.length;
    setCurrentItemIndex(function (index) {
      return direction === 'next' ? (index + 1) % length : (index - 1 + length) % length;
    });
  };
  var containerTransformStyle = (0, _react.useMemo)(function () {
    var _tableColumnRef$curre, _tableColumnRef$curre2;
    var minColumnWidth = (_tableColumnRef$curre = tableColumnRef === null || tableColumnRef === void 0 || (_tableColumnRef$curre2 = tableColumnRef.current) === null || _tableColumnRef$curre2 === void 0 ? void 0 : _tableColumnRef$curre2.offsetWidth) !== null && _tableColumnRef$curre !== void 0 ? _tableColumnRef$curre : 280;
    var gapInPixel = 15;
    return currentItemIndex !== Object.keys(visiblePlans).length - 1 || currentItemIndex === 0 ? "translate(calc(-".concat(minColumnWidth * currentItemIndex, "px - ").concat(currentItemIndex * gapInPixel, "px), 0)") : "translate(calc(-".concat(minColumnWidth * currentItemIndex, "px - ").concat(currentItemIndex * gapInPixel, "px + 10%))");
  }, [currentItemIndex, visiblePlans]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("ul", {
    ref: containerRef,
    style: {
      transform: containerTransformStyle
    },
    className: "productsTableList ".concat(layout)
  }, Object.entries(visiblePlans).map(function (_ref2) {
    var _visibilityMap$key;
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      plan = _ref3[1];
    var plans = _defineProperty({}, key, plan);
    var isVisible = (_visibilityMap$key = visibilityMap[key]) !== null && _visibilityMap$key !== void 0 ? _visibilityMap$key : false;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: key,
      ref: tableColumnRef,
      className: "productsTableItem ".concat(isVisible ? 'isVisible' : '')
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: "productsTable ".concat(showProductSelectFooters ? 'withSelectFooters' : '')
    }, /*#__PURE__*/_react["default"].createElement(_productsTableHead.ProductsTableHead, {
      plans: plans,
      contentToggleable: contentToggleable,
      onActiveProductGroupChange: onActiveProductGroupChange,
      onPlanSelect: onPlanSelect,
      planKey: key,
      onTogglePlanVisibility: function onTogglePlanVisibility() {
        return _onTogglePlanVisibility(key);
      },
      plansVisible: isVisible
    }), (!contentToggleable || contentToggleable && isVisible) && /*#__PURE__*/_react["default"].createElement(_productsTableBody.ProductsTableBody, {
      plans: plans,
      onSelectedOptionChange: onSelectedOptionChange,
      onGroupDisplayStateChange: onGroupDisplayStateChange
    })));
  })), shouldShowControl && layout === 'horizontal' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "sliderControl right",
    onClick: function onClick(event) {
      event.preventDefault();
      SwipeInDirection('next');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Click to show next item"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "caret_right"
  })), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "sliderControl left",
    onClick: function onClick(event) {
      event.preventDefault();
      SwipeInDirection('previous');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Click to show previous item"), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    icon: "caret_left"
  }))));
};
ProductsTableMobileLayout.propTypes = {
  layout: _propTypes["default"].oneOf(['stacked', 'horizontal']),
  showProductSelectFooters: _propTypes["default"].bool,
  onPlanSelect: _propTypes["default"].func,
  onActiveProductGroupChange: _propTypes["default"].func,
  onGroupDisplayStateChange: _propTypes["default"].func,
  onSelectedOptionChange: _propTypes["default"].func,
  onTogglePlanVisibility: _propTypes["default"].func,
  /* eslint-disable-next-line react/forbid-prop-types */
  visiblePlans: _propTypes["default"].object
};